import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout as AntLayout } from 'antd';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import BackToTop from '../../components/BackToTop/BackToTop';
import './AppLayout.css';

const { Content } = AntLayout;

const AppLayout: React.FC = () => {
  console.log("AppLayout is rendering!");
  return (
    <AntLayout style={{ minHeight: '100vh', background: '#ffffff' }}>
      {/* Global Header */}
      <Header />

      {/* Main Content Area */}
      <AntLayout className="site-layout">
        <Content style={{ width: '100%', padding: '0', background: '#ffffff' }}>
          <div className="site-layout-background" style={{ padding: 0, minHeight: 380 }}>
            <div className="app-container">
              <Outlet />
            </div>
          </div>
        </Content>
        {/* Global Footer */}
        <Footer />
      </AntLayout>

      {/* Scroll to Top Button */}
      <BackToTop />
    </AntLayout>
  );
};

export default AppLayout;
